import { appName } from '@/ui/utils/utils';
import { ValueProvider } from '@juvare/common-form-ui/ValueProvider';
import { buildPublicDataValueProvider } from '@juvare/platform-sdk-react/ui/features/classifiers';

export function buildHanRolesValueProvider(): ValueProvider {
    return buildPublicDataValueProvider({ appName, classifierName: 'hanRole', label: 'Han Roles' });
}
